import {MI} from "../init";
import AbstractSymbol from "../symbol/AbstractSymbol";
import {madnes_get_json} from "../../framework/src/engine/madnes/madnes";
import {systemConfig, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {CONFIG_PARAMS} from "../../framework/src/system/SystemConfig";
import {wintable_phaser} from "../../framework/src/engine/madnes/MadnesApp";

/**
 * @constructor
 */
export default function GameInfo() {

    /**
     * @type {SymbolsManager}
     */
    this._symbolsManager;

    /**
     * @constant
     * @type {number}
     */
    this._slideDuration = 500;

    /**
     * @type {ServerConfig}
     */
    this._serverConfig;

    //this._slidesCount = 3;

    /**
     * @private
     * @type {Array<MadnesGroup>}
     */
    this._slidesGroups = [];

    /**
     * @private
     * @type {number}
     */
    this._pos = 0;

    /** @type {!Object<string, MadnesObject>} */
    this._texts = {};

    /** @type {!Array<MadnesObject>} */
    this._slidesBgs = [];

    this._objects = [];

    /**
     * @type {boolean}
     * @private
     */
    this._locked = false;

    /** @type {MadnesObject} */
    this._winningLines;

    /** @type boolean */
    this._opened = false;
};

/**
 * @param {string=} lang
 */
GameInfo.prototype._getWildPos = function(lang) {

    switch(lang) {
        case "en": return { 'x': 245, 'y': 470 };
        default: return { 'x': 215, 'y': 470 };
    }
};

GameInfo.prototype._getScatterPos = function(lang) {

    switch(lang) {
        case "en": return { 'x': 230, 'y': 220 };
        default: return { 'x': 230, 'y': 220 };
    }
};

/**
 * @param {ServerConfig} serverConfig
 * @param {SymbolsManager} symbolsManager
 */
GameInfo.prototype.init = function(serverConfig, symbolsManager) {
    this._symbolsManager = symbolsManager;
    this._serverConfig = serverConfig;

    this._phaser = wintable_phaser;

    for(var i = 0; i < 6; i++) {
        this._slidesGroups.push(MI.addGroup("infotable_group_" + i, this._phaser));
    }
};

GameInfo.prototype.create = function() {
    let lang = systemConfig.get(CONFIG_PARAMS.LANGUAGE);

    this._objects.push(MI.addImg(0, 0, "wintable_1"));
    this._objects.push(MI.addImg(0, 0, "wintable_2"));
    this._objects.push(MI.addImg(0, 0, "wintable_4"));
    this._objects.push(MI.addImg(0, 0, "wintable_4"));
    this._objects.push(MI.addImg(0, 0, "wintable_4"));
    this._objects.push(MI.addImg(0, 0, "wintable_4"));

    for(var i = 0; i < this._objects.length; i++) {
        this._slidesGroups[i].add(this._objects[i]);
    }

    this._winningLines = MI.addImg(MI.getWi() / 2 - 12, MI.getHe() / 2, "info_winlines");
    this._winningLines.setAnchor(0.5, 0.5);
    this._slidesGroups[5].add(this._winningLines);

    for(var i = 0; i < 5; i++) {
        var logo = MI.addImg(MI.getWi() / 2, 0, "reels_atlas").setFrameName("logo_reels");
        logo.setAnchor(0.5, 0);
        this._objects.push(logo);

        this._slidesGroups[i + 1].add(logo);
    }

    var txt = "";

    this._texts = {
        'symbol_Crystal_red_5': MI.addBitmapText("font_wintable", 355, 80, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Crystal_red_4': MI.addBitmapText("font_wintable", 355, 132, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Crystal_red_3': MI.addBitmapText("font_wintable", 355, 182, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Crystal_red_2': MI.addBitmapText("font_wintable", 355, 232, txt, 80).setAnchor(0.5, 0.5),

        'symbol_Crystal_blue_5': MI.addBitmapText("font_wintable", 920, 80, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Crystal_blue_4': MI.addBitmapText("font_wintable", 920, 132, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Crystal_blue_3': MI.addBitmapText("font_wintable", 920, 182, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Crystal_blue_2': MI.addBitmapText("font_wintable", 920, 232, txt, 80).setAnchor(0.5, 0.5),

        'symbol_Ring_5': MI.addBitmapText("font_wintable", 355, 374, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Ring_4': MI.addBitmapText("font_wintable", 355, 424, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Ring_3': MI.addBitmapText("font_wintable", 355, 474, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Ring_2': MI.addBitmapText("font_wintable", 355, 524, txt, 80).setAnchor(0.5, 0.5),

        'symbol_Gold_5': MI.addBitmapText("font_wintable", 920, 374, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Gold_4': MI.addBitmapText("font_wintable", 920, 424, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Gold_3': MI.addBitmapText("font_wintable", 920, 474, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Gold_2': MI.addBitmapText("font_wintable", 920, 524, txt, 80).setAnchor(0.5, 0.5),

        'symbol_Pestle_5': MI.addBitmapText("font_wintable", 355, 114, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Pestle_4': MI.addBitmapText("font_wintable", 355, 164, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Pestle_3': MI.addBitmapText("font_wintable", 355, 216, txt, 80).setAnchor(0.5, 0.5),

        'symbol_Candle_5': MI.addBitmapText("font_wintable", 920, 114, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Candle_4': MI.addBitmapText("font_wintable", 920, 164, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Candle_3': MI.addBitmapText("font_wintable", 920, 216, txt, 80).setAnchor(0.5, 0.5),

        'symbol_A_5': MI.addBitmapText("font_wintable", 355, 420, txt, 80).setAnchor(0.5, 0.5),
        'symbol_A_4': MI.addBitmapText("font_wintable", 355, 470, txt, 80).setAnchor(0.5, 0.5),
        'symbol_A_3': MI.addBitmapText("font_wintable", 355, 522, txt, 80).setAnchor(0.5, 0.5),

        'symbol_Q_5': MI.addBitmapText("font_wintable", 920, 420, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Q_4': MI.addBitmapText("font_wintable", 920, 470, txt, 80).setAnchor(0.5, 0.5),
        'symbol_Q_3': MI.addBitmapText("font_wintable", 920, 522, txt, 80).setAnchor(0.5, 0.5)
    };

    for(var i = 2; i <= 5; i++) {
        this._slidesGroups[0].add(this._texts["symbol_Crystal_red_" + i]);
        this._slidesGroups[0].add(this._texts["symbol_Crystal_blue_" + i]);
        this._slidesGroups[0].add(this._texts["symbol_Ring_" + i]);
        this._slidesGroups[0].add(this._texts["symbol_Gold_" + i]);
    }

    for(var i = 3; i <= 5; i++) {
        this._slidesGroups[1].add(this._texts["symbol_Pestle_" + i]);
        this._slidesGroups[1].add(this._texts["symbol_Candle_" + i]);
        this._slidesGroups[1].add(this._texts["symbol_A_" + i]);
        this._slidesGroups[1].add(this._texts["symbol_Q_" + i]);
    }


    let multiplier = madnes_get_json("infotext")["multiplier"]["content"];
    let style = madnes_get_json("infotext")["multiplier"]["style"];
    let multiText = MI.addText(640,140, multiplier, style);
    multiText.setPosX(640-multiText.getWidth()/2);
    this._slidesGroups[1].add(multiText);

    var infotexts = madnes_get_json("infotext")['infomenuPages'];

    var apos = this._getWildPos(lang);
    var alchemist = this._symbolsManager.create("symbol_Alchemist", apos["x"], apos["y"]);
    alchemist.createSymbol();
    alchemist.createStandAnim();
    alchemist.setScale(0.7, 0.7);
    this._slidesGroups[2].add(alchemist.getSprite());
    this._objects.push(alchemist);

    var spos = this._getScatterPos(lang);
    var scatter = this._symbolsManager.create("symbol_Book", spos["x"], spos["y"]);
    scatter.createStandAnim(/*true*/);
    scatter.setScale(0.7, 0.7); //.setVisible(false);
    this._slidesGroups[4].add(scatter.getSprite());
    this._objects.push(scatter);


    for(var i = 0; i < infotexts.length; i++) {

        var x = infotexts[i]["position"][0];
        var y = infotexts[i]["position"][1];

        var page = infotexts[i]["page"];
        var lineHeight0 = infotexts[i]['title'] ? infotexts[i]['title']["lineHeight"] : 0;
        var lineHeight1 = infotexts[i]["lineHeight"];

        var style0 = {
            "font": "32px Arial",
            "fill": "#faba41",
            "fontWeight": "",
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotexts[i]["fontSize"] && infotexts[i]["font"])
        {
            style0["font"] = infotexts[i]["fontSize"] + "px " + infotexts[i]["font"];
            style1["font"] = infotexts[i]["fontSize"] + "px " + infotexts[i]["font"];
        }

        var line0 = 0;
        var line1 = 0;

        if(infotexts[i]["title"] && infotexts[i]["title"]["content"].length) {

            style0["fill"] = infotexts[i]["title"]["color"];
            style0["fontWeight"] = infotexts[i]["title"]["bold"] === 1 ? "bold" : "";


            for(var j = 0; j < infotexts[i]["title"]["content"].length; j++) {

                var text1 = infotexts[i]["title"]["content"][j];

                var t1 = MI.addText(x, y + line0 * lineHeight0, text1, style0);

                this._slidesGroups[page - 1].add(t1);
                this._objects.push(t1);

                line0++;
            }
        }

        if(infotexts[i]["body"] && infotexts[i]["body"]["content"].length) {

            style1["fill"] = infotexts[i]["body"]["color"];
            style1["fontWeight"] = infotexts[i]["body"]["bold"] === 1 ? "bold" : "";

            for(var j = 0; j < infotexts[i]["body"]["content"].length; j++) {
                var text2 = infotexts[i]["body"]["content"][j];
                var t2 = MI.addText(x, y + line0 * lineHeight0 + line1 * lineHeight1, text2, style1);

                this._slidesGroups[page - 1].add(t2);
                this._objects.push(t2);

                line1++;
            }
        }

        //console.log(style1["fontWeight"], style0["fontWeight"]);
    }

    this._hideAllSlides();
};

GameInfo.prototype.destroy = function() {
    for(var i in this._texts) {
        this._texts[i].destroy();
    }
    this._texts = {};

    for(var i = 0; i < this._objects.length; i++) {
        this._objects[i].destroy();
    }
    this._objects = [];

    this._winningLines.destroy();

    /*for(var i = 0; i < this._slidesGroups.length; i++) {
        this._slidesGroups[i].destroy();
    }
    this._slidesGroups = [];*/
};

GameInfo.prototype.update = function(bet) {

    if(!this._slidesGroups.length) {
        return;
    }

    var symbols = this._serverConfig.getSymbols();
    for(var i = 0; i < symbols.length; i++) {
        var factors = symbols[i]["factors"];
        var name = AbstractSymbol.getSymbolByNum(i);

        for(var factorIdx = 0; factorIdx < factors.length; factorIdx++) {
            var factor = factors[factorIdx];

            if(!factor) {
                factor = 1;
            }

            if(typeof this._texts[name + "_" + (factorIdx + 1)] === 'undefined') {
                continue;
            }

            this._texts[name + "_" + (factorIdx + 1)].setAdjustText(bet * factor, 9999);
        }
    }
};

GameInfo.prototype.open = function() {
    this._opened = true;
    this._show(this._pos);
};

GameInfo.prototype.slideLeft = function() {
    if(!this._opened) return;
    this._slide(-1);
};

GameInfo.prototype.slideRight = function() {
    if(!this._opened) return;
    this._slide(1);
};

/**
 * @private
 * @param {number} dir
 * @returns {undefined}
 */
GameInfo.prototype._slide = function(dir) {

    if(this._locked) {
        return;
    }

    this._locked = true;

    var nextPos = this._pos + dir;

    if(nextPos < 0) {
        nextPos = this._slidesGroups.length - 1;
    }

    if(nextPos >= this._slidesGroups.length) {
        nextPos = 0;
    }

    (function(_this, pos, _slides) {
        MI.addTween().to(_slides[pos], { 'x': wi * dir * -1 }, {
            'duration': _this._slideDuration,
            'callback': function() {
                _slides[pos].setVisible(false);
            }
        });
    } (this, this._pos, this._slidesGroups));


    this._slidesGroups[nextPos].setVisible(true);
    this._slidesGroups[nextPos].setPosX(wi * dir);

    MI.addTween().to(this._slidesGroups[nextPos], { 'x': 0 }, {
        'duration': this._slideDuration,
        'callback': function() {
            this._locked = false;
        }.bind(this)
    });

    this._pos = nextPos;
};

GameInfo.prototype.close = function() {
    this._hideAllSlides();
    this._opened = false;
};

GameInfo.prototype._show = function(slideId) {
    this._hideAllSlides();
    this._slidesGroups[slideId].setPos(0, 0);
    this._slidesGroups[slideId].setVisible(true);
};

GameInfo.prototype._hideAllSlides = function() {
    for(var i = 0; i < this._slidesGroups.length; i++) {
        this._slidesGroups[i].setVisible(false);
    }
};

GameInfo.prototype.showMain = function() {
    if(this._pos === 0) {
        return;
    }

    if(!this._locked) {
        this._slide(-1, 0);
    } else {
        this._slideCallbackOnce = () => {
            this._slide(-1, 0);
        }
    }
}
